import { DashboardInitResponse } from 'signature-public-api-sdk';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { LoginSuccessPayload } from '€slices/auth/auth-types';
import { UserState } from './user-types';
import { actions as authActions } from '€slices/auth/auth-slice';
import { actions as dashboardActions } from '€slices/dashboard/dashboard-slice';
import { actions as networkActions } from '€slices/network/network-slice';
import { SetValuePayloadAction } from '€slices/types';
import { User } from '../../types/User';

const initialState: UserState = {
    user: undefined,
    moneyHealth: undefined,
};

const slice = createSlice({
    name: 'user',
    initialState,
    reducers:
        process.env.NODE_ENV === 'development'
            ? {
                  setMoneyHealth: (
                      state,
                      { payload: { moneyHealth } }: SetValuePayloadAction<UserState, 'moneyHealth'>,
                  ) => ({ ...state, moneyHealth }),
              }
            : {},
    extraReducers: {
        [authActions.receiveLoginSuccess.type]: (
            state,
            action: PayloadAction<LoginSuccessPayload>,
        ) => ({
            ...state,
            user: action.payload.user,
        }),
        [authActions.receiveValidateAuthCookieSuccess.type]: (
            state,
            action: PayloadAction<User>,
        ) => ({
            ...state,
            user: action.payload,
        }),
        [authActions.logout.type]: () => initialState,
        [networkActions.timeout.type]: () => initialState,
        [dashboardActions.receiveDataSuccess.type]: (
            state,
            { payload: { moneyHealth } }: PayloadAction<DashboardInitResponse>,
        ) => ({
            ...state,
            moneyHealth: moneyHealth !== undefined ? moneyHealth : state.moneyHealth,
        }),
    },
});

export default slice;
export const { actions, reducer } = slice;
